import { render, staticRenderFns } from "./DashboardGestor.vue?vue&type=template&id=785f0f4b"
import script from "./DashboardGestor.vue?vue&type=script&lang=js"
export * from "./DashboardGestor.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestor.vue?vue&type=style&index=0&id=785f0f4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports